export default {
  date: 'YYYY-MM-DD',
  dateTime: 'YYYY-MM-DD HH:mm',
  dateTimeSec: 'YYYY-MM-DD HH:mm:ss',
};
